export default __webpack_public_path__ + "static/media/Careers.540370b7.jpeg";